import React from 'react';
import { VinDecoderContent } from 'site-modules/shared/components/vin-decoder/vin-decoder-content/vin-decoder-content';

export const VinDecoderEntry = () => {
  return (
    <div className="vin-decoder-entry my-4">
      <VinDecoderContent />
    </div>
  );
};

VinDecoderEntry.propTypes = {};
